import script from "./AbstractSubmissionReceipt.vue?vue&type=script&setup=true&lang=ts"
export * from "./AbstractSubmissionReceipt.vue?vue&type=script&setup=true&lang=ts"

import "./AbstractSubmissionReceipt.vue?vue&type=style&index=0&id=344d9a6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-344d9a6e"]])

export default __exports__